import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const refreshUserInvitation = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "users/refreshUserInvitation",
  async (userId: string, { extra: { adminRepository } }) => {
    return adminRepository!.refreshUserInvitation(userId);
  },
);

export const resetRefreshUserInvitation = createAction("users/resetRefreshUserInvitation");
